import React from "react";
import PropTypes from "prop-types";
import { FormControl, InputLabel } from "@mui/material";
import Clear from "@mui/icons-material/Clear";
import Check from "@mui/icons-material/Check";
import { MuiTelInput } from "mui-tel-input";
import stylesFunction from "../../assets/jss/material-dashboard-react/components/customInputStyle.js";
import resources from "../../core/Localization/Localization.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";

export default function CustomPhoneInput(props) {
    const styles = stylesFunction();
    const { formControlProps, labelText, id, labelProps, value, onChange, inputProps, error, success } = props;

    const labelData = {
        "labelRootError": error,
        "labelRootSuccess": success && !error
    };
    const labelKeys = getKeyArray(labelData);


    //LEAVED IN CASE WE NEED TO ADD THIS STYLE 
    // const underlineData = {
    //     "underlineError": error,
    //     "underlineSuccess": success && !error,
    //     "underline": true
    // };
    // const underlineKeys = getKeyArray(underlineData);


    const marginData = {
        "marginTop": labelText === undefined
    };
    const marginKeys = getKeyArray(marginData);


    const defaultValue = "+381";
    const defaultCountry = "RS";

    return (
        <FormControl
            {...formControlProps}
            sx={getBaseSxStyle(styles, ['formControl'])}
        >
            {labelText && (
                <InputLabel
                    {...labelProps}
                    sx={getBaseSxStyle(styles, ['labelRoot', ...labelKeys])}
                    htmlFor={id}
                >
                    {labelText}
                </InputLabel>
            )}

            <MuiTelInput
                value={value || defaultValue}
                defaultCountry={defaultCountry}
                onChange={(e) => (onChange ? onChange(e) : null)}
                fullWidth
                forceCallingCode
                placeholder={resources.createUser.phone}
                disabled={!!inputProps?.disabled}
                sx={getBaseSxStyle(styles, [...marginKeys])}
                id={id}
            />
            {
                error
                    ? (<Clear sx={getBaseSxStyle(styles, ['feedback', 'labelRootError'])} />)
                    : success
                        ? (<Check sx={getBaseSxStyle(styles, ['feedback', 'labelRootSuccess'])} />)
                        : null
            }
        </FormControl>
    );
}

CustomPhoneInput.propTypes = {
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    error: PropTypes.bool,
    success: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func,
};
